import { SurveyEngine_Models_Answer, SurveyEngine_Models_BaseResponse } from '../../../api'
import { GetValueInput, GetValueInputProps } from './GetValueInput'
import { GetValueSSN, GetValueSSNProps } from './GetValueSSN'


export enum InputLayout {
  SINGLE_LINE = 'SingleLine',
  MULTI_LINE = 'MultiLine',
  MULTI_SELECT = 'MultiSelect',
}

interface getValueValidation {
  dataType: string,
  confirmResponse: boolean,
  caseSensitive: boolean,
  characterCount: boolean,
  minCharacters: number,
  maxCharacters: number,
  postiveNumbersOnly: boolean,
  alphaNumericOnly?: boolean,
  inputHeight: number
  CompareList: Array<string>
}
interface GetValueProps {
  id: number,
  question: string,
  confirmQuestion: string,
  defaultAnswer: string,
  answers?: SurveyEngine_Models_Answer[]
  maskInput: boolean,
  Validation: getValueValidation,
  inputFormat?:string,
  isError:boolean,
  focus:boolean,
  callback: (response: SurveyEngine_Models_BaseResponse) => void
}
export const GetValue = (props: GetValueProps) => {
  let component = <></>
  let type = "text";
  let defaultAnswer = props.defaultAnswer ?? ""
  switch (props.Validation.dataType.toLocaleLowerCase()) {
    case 'socialsecuritynumber':
      {
        let inputProps: GetValueSSNProps = {
          id: props.id,
          question: props.question,
          confirmQuestion: props.Validation.confirmResponse ? props.confirmQuestion : undefined,
          minLength: props.Validation.minCharacters,
          maxLength: props.Validation.maxCharacters,
          defaultAnswer: props.defaultAnswer ?? "",
          focus:props.focus,
          inputFormat:props.inputFormat,
          callback: props.callback
        }
        component = <GetValueSSN {...inputProps} />
        break;
      }
    case 'numeric':      
    case 'date':
    case 'birthdate':
    case 'time':
    case 'phonenumber':
    case 'zipcode':
    case 'RunProcedure':
    case 'none':
    default:
      {
        if (props.maskInput)
          type = "password";
        else if (props.Validation.dataType.toLocaleLowerCase() === "date")
          {
            type = "date";
            if(defaultAnswer !== ""){
              defaultAnswer = formatDate();
            }
          }
          else if (props.Validation.dataType.toLocaleLowerCase() === "birthdate")
          {
            type = "birthdate";
            if(defaultAnswer !== ""){
              defaultAnswer = formatDate();
            }
          }
        else if (props.Validation.dataType.toLocaleLowerCase() === "time")
          type = "time"
        else if (props.Validation.dataType.toLocaleLowerCase() === "phonenumber")
          type = "tel"
        else if (props.Validation.dataType.toLocaleLowerCase() === "numeric")
          type = "number"
        else if( props.Validation.dataType.toLocaleLowerCase() === "emailaddress")
          type="email"
        let inputProps: GetValueInputProps = {
          id: props.id,
          type: type,
          positiveOnly:props.Validation.postiveNumbersOnly,
          alphaNumericOnly:props.Validation.alphaNumericOnly,
          question: props.question,
          confirmQuestion: props.Validation.confirmResponse ? props.confirmQuestion : undefined,
          minLength: props.Validation.minCharacters,
          maxLength: props.Validation.maxCharacters,
          layout: getInputLayout(),
          caseSensitive: props.Validation.caseSensitive,
          answers:props.answers,
          defaultAnswer: defaultAnswer,
          charCount:props.Validation.characterCount, 
          isError:props.isError,
          focus:props.focus,
          validationType: props.Validation.dataType,
          textboxHeight: props.Validation.inputHeight,
          callback: props.callback
        }
        component = <GetValueInput {...inputProps} />
      }

  }

  function getInputLayout() {
    if (props.answers !== undefined && props.answers.length > 0) {
      //ignore validation for multi select
      props.Validation.minCharacters = 0;
      return InputLayout.MULTI_SELECT;
    }
    else if ((props.Validation.dataType.toLocaleLowerCase()  === 'none' || props.Validation.dataType.toLocaleLowerCase() === "alphanumeric") &&
              props.Validation.inputHeight > 2) {
      return InputLayout.MULTI_LINE;
    }
    else {
      return InputLayout.SINGLE_LINE;
    }
  }
 
  function formatDate(){
    const parts = defaultAnswer.split('/');
    const paddedDateStr = parts.map(part => part.length === 1 ? '0' + part : part).join('/');
    return new Date(paddedDateStr).toISOString().split('T')[0];
  }
  return (
    <>
      {component}
    </>
  )
}
